module.exports = __webpack_public_path__ + "img/Info_o_vozidle.0e3e06da.svg";